import { getPageVisibilityState } from '../../hidden-timing';
function getPageVisibilityUpToTTAI(interaction) {
  const {
    start,
    end
  } = interaction;
  return getPageVisibilityState(start, end);
}
export default getPageVisibilityUpToTTAI;